import { render, staticRenderFns } from "./RescueNetPayorMapping2.vue?vue&type=template&id=70c74b45&"
import script from "./RescueNetPayorMapping2.vue?vue&type=script&lang=js&"
export * from "./RescueNetPayorMapping2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports